import { Component, Host, h, JSX, Prop } from '@stencil/core'

@Component({
    tag: 'zr-warning-notice',
    styleUrl: 'zr-warning-notice.scss',
    shadow: true,
})

/**
 * ZooRoyal price component.
 */
export class ZrWarningNotice {
    /**
     * Warning-notice headline.
     */
    @Prop() warning = ''

    /**
     * Warning-notice copy-text.
     */
    @Prop() notice: string | string[]

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                <div class="zr-warning-notice__wrapper">
                    <p>
                        <em>
                            {(this.warning !== '') && [
                                <strong>{this.warning}</strong>,
                                <br/>,
                            ]}
                            {Array.isArray(this.notice) && (
                                <ul>
                                    {this.notice.map(item => (
                                        <li>{item}</li>
                                    ))}
                                </ul>
                            ) || this.notice}
                        </em>
                    </p>
                </div>
            </Host>
        )
    }
}
